import React from 'react';
import Link from 'react-router/lib/Link';
import * as shapes from '../shapes';
import { formatDiscount } from '../helpers';

const Item = ({ discount, baseUrl, disabled, currency }) => (
  <Link className="c-table-card__row" to={disabled ? '' : `${baseUrl}/${discount.id}/edit`}>
    <div className="c-table-card__cell">{discount.name}</div>
    <div className="c-table-card__cell">{formatDiscount(discount, currency)}</div>
    <div className="c-table-card__cell">{discount.assignment || 'services & products'}</div>
  </Link>
);

Item.propTypes = {
  discount: shapes.discount.isRequired,
  baseUrl: shapes.url.isRequired,
  disabled: shapes.flag.isRequired,
  currency: shapes.string.isRequired,
};

export default Item;
